import { Typography, TypographyTypeMap } from '@mui/material'
import { ElementType } from 'domelementtype'
import parse, { DOMNode } from 'html-react-parser'
import { renderMarkdownToHtml } from '@omnea-app/frontend/utils/markdown/renderMarkdownToHtml'

interface Props {
  markdownString: string
  typographyProps?: TypographyTypeMap['props']
}

const RenderMarkdown = ({ markdownString, typographyProps }: Props): React.ReactElement => {
  const TransformFunc = (node: DOMNode) => {
    if (node.type === ElementType.Tag && node.name === 'a' && node.attribs) {
      // NOTE(Rhys): Open links in new tabs
      node.attribs.target = '_blank'
      // NOTE(Rhys): Update links to look like links
      node.attribs.style = 'cursor: pointer; text-decoration: underline; color: rgb(0, 0, 238);'
    }
  }

  return (
    <Typography
      sx={{
        display: 'block',
      }}
      {...typographyProps}
    >
      {parse(renderMarkdownToHtml(markdownString), {
        replace: TransformFunc,
      })}
    </Typography>
  )
}

export { RenderMarkdown }
